export const adminData =
  "flex flex-col overflow-y-auto scrollbar-thin scrollbar-track-white scrollbar-thumb-black h-[35rem]  shadow-lg pl-5 rounded-md overflow-x-hidden";

export const adminDataBody =
  "grid grid-cols-24 hover:scale-105 transition-all duration-150";

export const adminDataHeading = "font-bold py-2 px-2";
export const adminDataBodyFields = "py-2 px-2";

export const adminFormSubmitButton =
  "bg-red-500 w-24 h-8 rounded-md text-white hover:scale-105 hover:bg-red-700 transition-all duration-200 ";
export const adminFormClearButton =
  "bg-blue-500 w-24 h-8 rounded-md text-white hover:scale-105 hover:bg-blue-700 transition-all duration-200";
export const adminFormButton = "self-center space-x-6";

export const adminForm0 = "flex flex-col mb-6";
export const adminForm1 = "flex py-10 ml-10 space-x-28";
export const adminForm2l = "flex flex-col space-y-10";
export const adminForm2r = "flex flex-col space-y-10 pr-6";
export const adminForm3 = "grid grid-cols-2  gap-10";

export const adminLabel =
  "font-bold text-lg bg-gray-700 shadow-xl text-white px-2 py-1 rounded-lg";
export const adminInput = "border-2 px-2 py-1 text-sm";

export const loadingAndError = "flex justify-center mt-6";
